import { render } from "./CoffeeUpsert.vue?vue&type=template&id=20df6db1&scoped=true"
import script from "./CoffeeUpsert.vue?vue&type=script&lang=js"
export * from "./CoffeeUpsert.vue?vue&type=script&lang=js"

import "./CoffeeUpsert.vue?vue&type=style&index=0&id=20df6db1&scoped=true&lang=css"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20df6db1"]])

export default __exports__